import Iconify from "@/components/ui/Iconify";
import PDW_HomeAddressContactInfoSection from "./pdw-home-address-contact-info-section";
import PDW_HomeMenuSection from "./pdw-home-menu-section";
import PDW_HomeClipSection from "./pdw-home-clip-section";
import PDW_HomeVisitorMediaGridSection from "./pdw-visitor-media-grid-section";
import PDW_HomeVisitorReviewsSection from "./pdw-home-visitor-reviews-section";
import { useTranslations } from "@/lib/static-intl";
import { useAuthContext } from "@/context/auth/useAuthContext";
import { isApiPlace } from "@/utils/placeUtils";

const PDW_PlaceTabHomeSection = ({
  place,
  placesMenuLoader,
  placeMenus,
  placeMedia,
  placeTextReviews,
  setCurrentTab,
  openPlaceMediaSlider,
  isCssForDialog,
  openFullScreenModal,
  handleContentModalOpen = () => {},
}) => {
  const t = useTranslations("places.place_details_window");
  const { user, openLoginModal } = useAuthContext();
  return (
    <div className="w-full min-h-[70vh] flex flex-col px-0 gap-2 pb-5">
      {/* Menu Section - Only show for DB places, not API places */}
      {!isApiPlace(place) && (
        <PDW_HomeMenuSection
          place={place}
          placeMenu={placeMenus}
          setCurrentTab={setCurrentTab}
          isCssForDialog={isCssForDialog}
          placesMenuLoader={placesMenuLoader}
          openPlaceMediaSlider={openPlaceMediaSlider}
        />
      )}
      {/* Intro Section (surfaced on home, 2026-07-23) */}
      {place?.introduction && (
        <div className="w-full flex flex-col gap-2 py-3">
          <div className="text-xs font-extrabold tracking-wide text-black/40 dark:text-white/40">
            소개
          </div>
          <p className="text-[15px] leading-relaxed text-black/80 dark:text-white/80 whitespace-pre-line">
            {place.introduction}
          </p>
          <div className="h-[1px] w-full bg-black/[0.08] dark:bg-white/[0.12] mt-1" />
        </div>
      )}
      {/* Address and Contact Info Section */}
      <PDW_HomeAddressContactInfoSection place={place} />
      <div className="w-full flex items-center">
        <div className="h-[1px] w-full bg-black/[0.08] dark:bg-white/[0.12]" />
        <button
          type="button"
          className="w-fit py-1.5 px-4 rounded-full bg-black/5 dark:bg-white/5 text-black/70 dark:text-white/70 text-sm flex items-center text-nowrap"
          onClick={() => setCurrentTab("Information")}
        >
          {t("view more info")}
          <Iconify
            icon={"lsicon:right-outline"}
            className={"!text-inherit !mt-0.5"}
          />
        </button>
        <div className="h-[1px] w-full bg-black/[0.08] dark:bg-white/[0.12]" />
      </div>
      <div className="w-full flex flex-col gap-4 py-2">
        {!isApiPlace(place) && (
          <button
            type="button"
            onClick={() => {
              if (!user?.userId) {
                openLoginModal();
                return;
              }
              // Use the correct place identifier for DB places
              const placeIdentifier = place?.id || place?._id;
              if (placeIdentifier) {
                window.open(`/places/suggest-edit/${placeIdentifier}`, "_blank");
              }
            }}
            className="w-full flex items-center gap-2 px-2"
          >
            <Iconify
              icon={"ri:edit-line"}
              className={"!text-black/45 dark:!text-white/50 !min-w-4 !w-4 !h-4"}
            />
            <span className="text-nowrap text-black/45 dark:text-white/50 text-sm">
              {t("edit_place_info")}
            </span>
            <Iconify
              icon={"formkit:right"}
              className={"!text-black/45 dark:!text-white/50 !min-w-4 !w-4 !h-4 !-ml-2"}
            />
          </button>
        )}
        <div className="h-[1px] w-full bg-black/[0.08] dark:bg-white/[0.12]" />
      </div>
      {/* Clip Section */}
      <PDW_HomeClipSection
        place={place}
        isCssForDialog={isCssForDialog}
        openFullScreenModal={openFullScreenModal}
      />
      {/* Visitor Media Grid Section */}
      <PDW_HomeVisitorMediaGridSection
        place={place}
        placeMedia={placeMedia}
        setCurrentTab={setCurrentTab}
        openPlaceMediaSlider={openPlaceMediaSlider}
      />
      {/* Visitor Reviews Section */}
      <PDW_HomeVisitorReviewsSection
        place={place}
        setCurrentTab={setCurrentTab}
        isCssForDialog={isCssForDialog}
        placeTextReviews={placeTextReviews}
        handleContentModalOpen={handleContentModalOpen}
      />
    </div>
  );
};

export default PDW_PlaceTabHomeSection;
